/*
 * @Author: 谭聪 156638174@qq.com
 * @Date: 2023-08-19 12:29:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-10-15 19:08:53
 * @FilePath: /mall-fe/src/comps/ShopModuleFloor.tsx
 * @Description: 渲染店铺楼层模块
 *
 */
import { getShopPackageSkuList, shopSearchSpuList } from 'api/shop';
import useAreaCookie from 'hooks/useAreaCookie';
import useUrl from 'hooks/useUrl';
import left from 'images/cscec3b/jczq-t-left';
import leftw from 'images/cscec3b/jczq-t-leftw';
import { DeviceContext, SiteContext } from 'libs/contexts';
import { webps } from 'libs/imgs';
import { formatPrice } from 'libs/utils';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { cls } from 'reactutils';
import AreaEmptyData from './AreaEmptyData';
import Container from './Container';
import PlaceholderImage from './PlaceholderImage';

webps[left] = leftw;

type FloorConfig = DeepNullable<{
  productCount: number;
  rows: any[];
  showSort: number;
  titleImg: string;
  titleTxt: string;
  titleType: number;
  customCategorySysNoList: Array<any>;
  productTagList: number[];
  upstreamSupplierSysNoList: number[];
  keyword: string;
}>;

/**
 * React组件，用于渲染店铺楼层模块。
 *
 * @param {Object} props - 组件的属性对象。
 * @param {FloorConfig} props.jsonConfig - 当前楼层的配置对象。
 * @param {any} props.shopData - 店铺数据。
 * @returns {JSX.Element} 渲染的React元素，显示店铺楼层内容。
 */
export default function ShopModuleFloor({
  jsonConfig,
  shopData,
}: {
  jsonConfig: FloorConfig;
  shopData: any;
}) {
  const { buildImgSrc } = useContext(DeviceContext);
  const router = useRouter();
  const [listData, setListData] = useState([]);
  const { getCookieAreacode } = useAreaCookie();
  const productCount = jsonConfig?.productCount || 4;
  const { getPublicUrl } = useUrl();
  const { shopSysNo } = router?.query || {};

  function getList() {
    const json = {
      areaLevelCode: getCookieAreacode(),
      pageNo: 1,
      pageSize: 30,
      shopSysNoList: [shopSysNo],
      sorts: [{ sortField: '', orderBy: 1 }],
      keywords: undefined,
      tagSysNoList: undefined,
      shopCustomCategorySysNoList: undefined,
      upstreamSupplierSysNoList: undefined,
    };

    // 如果存在产品标签列表，将标签列表添加到请求参数
    if (jsonConfig.productTagList?.length) {
      json.tagSysNoList = jsonConfig.productTagList;
    }

    // 如果存在自定义分类列表，将分类列表添加到请求参数
    if (jsonConfig.customCategorySysNoList) {
      json.shopCustomCategorySysNoList = jsonConfig.customCategorySysNoList;
    }

    // 如果存在上游供应商列表，将供应商列表添加到请求参数
    if (jsonConfig.upstreamSupplierSysNoList) {
      json.upstreamSupplierSysNoList = jsonConfig.upstreamSupplierSysNoList;
    }

    // 如果存在关键字，将关键字添加到请求参数
    if (jsonConfig.keyword) {
      json.keywords = jsonConfig.keyword;
    }

    // 如果配置中要求显示排序方式
    if (jsonConfig.showSort) {
      if (jsonConfig.showSort === 1) {
        // 如果要求按销量排序，设置排序参数为按销量降序
        json.sorts = [{ sortField: 'sellCount', orderBy: 2 }];
      } else if (jsonConfig.showSort === 2) {
        // 如果要求按销量排序，设置排序参数为按销量降序
        json.sorts = [{ sortField: 'salesPrice', orderBy: 1 }];
      } else if (jsonConfig.showSort === 3) {
        // 如果要求按店铺评分排序，设置排序参数为按店铺评分降序
        json.sorts = [{ sortField: 'shopScore', orderBy: 2 }];
      }
    }

    // 调用 shopSearchSpuList 函数进行商品搜索，返回 Promise
    return shopSearchSpuList({
      json,
    }).then((res) => {
      if (res?.data?.spuList?.datas?.length > 0) {
        return res.data.spuList.datas;
      } else {
        return [];
      }
    });
  }

  function sortConfigRows(arr = []) {
    return arr.sort((a, b) => a.priority - b.priority);
  }

  function getConfigRows(skuSysNoList = []) {
    if (skuSysNoList.length === 0) return [];
    return getShopPackageSkuList({
      json: {
        skuSysNoList: skuSysNoList.slice(0, 30),
        queryAttribute: false,
        queryCanSale: true,
      },
    }).then((res) => {
      const rows = res.data as any[];
      rows.forEach((item) => {
        item.priority = jsonConfig.rows.find((x) => x.sysNo === item.sysNo).priority;
      });
      return sortConfigRows(rows);
    });
  }

  useEffect(() => {
    Promise.all([getConfigRows(jsonConfig?.rows?.map((x) => x.sysNo)), getList()]).then(
      ([configRows, searchRows]) => {
        // console.log({
        //   configRows,
        //   searchRows,
        // })

        const filtered = searchRows.filter(
          (x) => !configRows.find((y) => y.sysNo === x.bestSkuSysNo),
        );

        setListData([...configRows, ...filtered]);
        // setListData(configRows);
      },
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonConfig?.rows]);

  return (
    <>
      <div className="floor-wrap">
        {jsonConfig.titleType ? (
          <div>
            {jsonConfig.titleType === 1 ? (
              <div className="title-img">
                <img src={getPublicUrl(jsonConfig.titleImg)} alt="" />
              </div>
            ) : (
              <div className={cls('title-txt', shopData.type === 1 ? 'homepage' : null)}>
                <img src={buildImgSrc(left)} alt="" />
                <span>{jsonConfig.titleTxt}</span>
                <img src={buildImgSrc(left)} alt="" className="right" />
              </div>
            )}
          </div>
        ) : null}
        {listData.length > 0 ? (
          <Container>
            <div className="rows">
              {listData.slice(0, productCount).map((row, index) => (
                // 创新专区店铺特殊处理，不显示价格@张政需求
                <FloorItem
                  data={{
                    ...row,
                    shopPriceFlag: shopSysNo === '1047548387118899707' ? 1 : row.shopPriceFlag,
                  }}
                  key={index}
                />
              ))}
            </div>
          </Container>
        ) : (
          <AreaEmptyData />
        )}
      </div>
      <style jsx>{`
        .floor-wrap :global(.container) {
          overflow: hidden;
        }
        .title-img {
          width: 100%;
          position: relative;
          user-select: none;
          overflow: hidden;
        }
        .title-img img {
          width: 100%;
        }
        .title-txt {
          font-size: 36px;
          color: #333333;
          letter-spacing: 0;
          text-align: center;
          line-height: 116px;
          font-weight: 500;
          height: 116px;
        }
        .title-txt.homepage {
          background: #fff;
        }
        .title-txt span {
          padding: 0 12px;
        }
        .title-txt img {
          width: 20px;
        }
        .title-txt img.right {
          transform: rotateY(0.5turn);
        }
        .rows {
          margin-top: 40px;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          width: 1320px;
        }
      `}</style>
    </>
  );
}

/**
 * React组件，用于渲染店铺楼层中的单个商品项。
 *
 * @param {Object} props - 组件的属性对象。
 * @param {any} props.data - 商品数据。
 * @returns {JSX.Element} 渲染的React元素，显示单个商品项。
 */
function FloorItem({ data }) {
  const site = useContext(SiteContext);
  const showPriceRange = site?.mall?.skuPriceShowWay === 1;
  const salePrice =
    data.lowestPrice === data.highestPrice || !showPriceRange
      ? data.lowestPrice || data.salesPrice
      : data.bestSkuSalesPrice;
  const { getPublicUrl } = useUrl();

  function handleClick() {
    window.open(`/product/detail?id=${data.bestSkuSysNo || data.sysNo}`);
  }

  const imgTags = data.imageProductTag || data.productTagImageList || [];
  const titleTags = data.titleProductTag || data.productTagTitleList || [];

  return (
    <>
      <div onClick={handleClick} title={data.name} className="grid-item">
        <div className="preview">
          <div className="preview-bd">
            <PlaceholderImage
              src={getPublicUrl(data.mainImage || data.images?.[0])}
              height={'100%'}
              width={'100%'}
            />
          </div>
        </div>
        {imgTags.map((item, index) => (
          <div className="grid-img-tag" key={index}>
            {item.tagName}
          </div>
        ))}
        <div className="grid-item-title">
          {titleTags.map((item, index) => (
            <div key={index} className="grid-title-tag">
              {item.tagName}
            </div>
          ))}
          <span title={data.name}>{data.name}</span>
        </div>
        <div className="grid-item-price">
          <span className="currency">¥</span>
          {/* TODO 20230726 新增 shopPriceFlag 字段，1表示询价，2表示展示价格 */}
          {data.shopPriceFlag === 2 && (
            <>
              <span className="text">{formatPrice(salePrice)}</span>
              <span className="separator">/</span>
              <span className="unit">{data.unitName || data.unit}</span>
            </>
          )}
          {data.shopPriceFlag === 1 && <span className="text">待询价</span>}
        </div>
      </div>
      <style jsx>{`
        .grid-item {
          font-size: 12px;
          display: block;
          width: 276px;
          height: 373px;
          padding: 20px 20px 0 20px;
          background-color: #fff;
          position: relative;
          cursor: pointer;
          margin-bottom: 33px;
          margin-right: 32px;
        }
        .preview {
          height: 236px;
        }

        .preview-bd {
          overflow: hidden;
          width: 236px;
          height: 236px;
          margin-bottom: 16px;
        }
        .preview-bd img {
          width: 100%;
          height: 100%;
        }

        .grid-item .grid-item-price {
          color: #fa5400;
          margin-top: 10px;
          line-height: 16px;
          white-space: nowrap;
        }

        .grid-item .grid-item-price .currency,
        .grid-item .grid-item-price .separator,
        .grid-item .grid-item-price .unit {
          font-size: 16px;
          margin-right: 2px;
        }

        .grid-item .grid-item-price span {
          display: inline-block;
          vertical-align: middle;
        }

        .grid-item .grid-item-price .hypen,
        .grid-item .grid-item-price .text {
          font-size: 16px;
        }

        .grid-item .grid-item-price .separator {
          margin-left: 2px;
        }

        .grid-item .grid-item-title {
          color: #222;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-top: 16px;
          height: 44px;
          max-height: 44px;
          font-weight: 400;
          font-size: 16px;
        }

        .grid-item .grid-title-tag {
          padding: 3px;
          background: var(--primaryColor);
          border-radius: 1px;
          margin-right: 7px;
          transform: translateY(-2px);
        }

        .grid-item .grid-img-tag,
        .grid-item .grid-title-tag {
          font-size: 12px;
          color: #fff;
          line-height: 1;
          display: inline-block;
        }

        .grid-item .grid-item-company,
        .grid-item .grid-item-spec {
          max-width: 100%;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          word-wrap: normal;
          white-space: nowrap;
        }

        .grid-item .grid-item-spec {
          line-height: 12px;
          color: #666;
          height: 12px;
        }

        .grid-item .grid-item-company,
        .grid-item .grid-item-spec {
          margin-top: 10px;
        }

        .mt10 {
          margin-top: 10px;
        }
        .mt5 {
          margin-top: 5px;
        }

        .sell-count {
          float: right;
        }
        .grid-item:hover {
          transform: translate3d(0, -2px, 0);
          box-shadow: 0 2px 8px 0 rgb(0 0 0 / 8%);
        }
        .grid-item .grid-img-tag {
          position: absolute;
          top: 26px;
          left: 26px;
          background-color: rgba(245, 34, 45, 0.9);
          padding: 4px 6px 3px;
        }
        // .grid-item .grid-item-is-allow-transactions .warn-content {
        //   background: #ff4848;
        //   color: #fff;
        //   padding: 2px 5px;
        //   border-radius: 3px;
        // }
      `}</style>
    </>
  );
}
